import React from "react";
import { Card, Select } from "antd";

const { Option } = Select;

const categories = [
  "England", "Spain", "Italy", "Germany", "France", "Netherlands", "Scotland", "Champions League", "Europa League", "Europa Conference", "Africa Cup Of Nations", "International"
  ,"World Cup", "UEFA Nations League", "UEFA Women's CL", "Women's World Cup", "Women's Euro", "UEFA Youth League", "Euro U21", "Africa Nat Champ","EURO 2020","CONCACAF"
];
const Categories = () => {
  return (
    <div>
      <Card className="sidebarCard">
        <h1 className="text-lg font-bold">Category Filter</h1>
        <Select defaultValue="Select League" style={{ width: "100%", marginTop: 20 }} className="fav-teams">
          <Option value="jack">England</Option>
          <Option value="lucy">France</Option>
          <Option value="Yiminghe">Spain</Option>
        </Select>
      </Card>
      {categories.map((item, i) => (
        <div className="w-60 p-2 categories-card mt-1" key={i}>
          <Card>
            <h3>{item}</h3>
          </Card>
        </div>
      ))}
    </div>
  );
};

export default Categories;